<template>
  <div class="h-full overflow-hidden">
    <div class="icon-search__input mt-10px mb-10px">
      <el-input placeholder="输入名称搜索" v-model="treeKeyWords" size="small" clearable>
        <i slot="append" class="el-icon-search cursor-pointer"></i>
      </el-input>
    </div>
    <div class="tree-box" v-loading="treeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
      <el-tree
        class="three-tree"
        ref="treeDom"
        node-key="id"
        :default-expand-all="false"
        :data="treeData"
        :props="{ children: 'children', label: 'name' }"
        :filter-node-method="filterTreeNode"
        :current-node-key="currentNodeInfo.id"
        :default-expanded-keys="defaultExpandKey"
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div @click="handletreeClick(data)">{{ node.label }}</div>
        </div>
      </el-tree>
    </div>
    <!-- 全局loading -->
    <div
      class="mask"
      v-if="loading"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
      :element-loading-text="'系统加载中'"
    ></div>
  </div>
</template>

<script>
import {
  VirtualTagTreeApi,
  VirtualTagTreeTagRelationApi,
  TagAnimationApi,
} from '@wiz-api/tag-roam-sis-management'
import { loadParticle } from '@/utils/dynamicEffect/particleVulkan'
import UVAnimation from '@/utils/dynamicEffect/UVAnimation'
import { loadRotationAction } from '@/utils/dynamicEffect/rotate'

const virtualTagTreeApi = new VirtualTagTreeApi()
const tagAnimationApi = new TagAnimationApi()
const virtualTagTreeTagRelationApi = new VirtualTagTreeTagRelationApi()

let perspective = {}
export default {
  name: 'sisSystem',
  components: {},
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeTab: '三维',
      tabList: ['三维', '设备资料'],
      treeKeyWords: '',
      loading: false,
      treeLoading: false,
      treeData: [],
      defaultExpandKey: [],
      currentNodeInfo: {},
      visibleList: [], // 所有设备模型树指针item
      animationList: [],
      dynInfo: {
        rotDatas: [], // node指针
        pipeDatas: [], // clip指针
        particleNodes: [], // 粒子节点指针
      },
      modelSourceId: '',
    }
  },
  watch: {
    treeKeyWords(val) {
      val = val.replace(/(^\s*)|(\s*$)/g, '')
      this.$refs.treeDom.filter(val)
    },
    visibleList() {
      this.sendInfoToRightDialog('detail', { id: this.currentNodeInfo.id })
    },
    transferProps(val, oValue) {
      if (val.id !== oValue.id && this.treeData.length > 0) {
        this.getTreeData()
      }
    },
  },
  methods: {
    setCheckDisable(bol) {
      const disableEvent = new CustomEvent('setCheckDisable', {
        detail: {
          disable: bol,
        },
      })
      window.dispatchEvent(disableEvent)
    },
    // 传递信息给二级弹框
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'DeviceList', origin: 'SisSystem', name: '设备资料' },
        type,
        props: data,
      })
    },
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 点击树
    async handletreeClick(data) {
      if (!data.parentId) {
        if (this.currentNodeInfo.id === data.id) return
        this.currentNodeInfo = data
        // 点击跟节点
        this.clickRootTree()
        return
      }
      if (data.children && data.children.length) return
      if (this.currentNodeInfo.id === data.id) {
        if (this.currentNodeInfo.perspective) {
          this.player.Native.Camera.moveTo(perspective.eye, perspective.target, perspective.up, 0)
        }
        return
      }
      this.currentNodeInfo = { ...data }
      await this.destroyDyn()
      await this.getTagList()
    },
    // 点击树的根节点
    async clickRootTree() {
      this.visibleList = []
      await this.setRootModelShow(true)
      await this.backInitPositon()
      await this.destroyDyn()
      this.setDisabledPanel(true)
    },
    // 获取左侧树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await virtualTagTreeApi.getDisplayVirtualTagTree({
        sceneId: this.sourceId,
      })
      if (!err) {
        // 自动展开根节点
        if (Array.isArray(res) && res.length > 0) {
          const rootNode = res[0]
          this.defaultExpandKey = [rootNode.id]
        }
        this.treeData = Object.freeze(res)
        if (this.transferProps?.id && this.transferProps.toDefaultOpen === 'SisSystem') {
          // 有默认选中的树id
          this.currentNodeInfo.id = this.transferProps.id
          this.defaultExpandKey = [...this.defaultExpandKey, this.transferProps.id]
          this.$nextTick(async () => {
            this.$refs.treeDom.setCurrentKey(this.transferProps.id)
            await this.getTagList()
            this.transferProps.id = ''
            this.transferProps.toDefaultOpen = ''
          })
        }
      }
      this.treeLoading = false
    },
    // 获取显示的三维设备
    async getTagList() {
      this.loading = true
      const [err, res] = await virtualTagTreeTagRelationApi.getTagDetailInfoByVirtualTagTreeIdId({
        virtualTagTreeId: this.currentNodeInfo.id,
      })
      if (!err) {
        const params = []
        const codeList = []
        res.datas?.forEach((item) => {
          params.push({
            code: item.tagCode,
          })
          codeList.push(item.tagCode)
        })
        await this.setDisabledPanel(false, codeList)
        await this.getAnimationList()
        const codeRes = await this.player.Native.Node.findNode(0, {
          codes: codeList,
        })
        const visibleList = []
        if (codeRes.codes) {
          codeList.forEach((code) => {
            codeRes.codes[code] ? visibleList.push(codeRes.codes[code].node) : ''
          })
        }
        await this.setRootModelShow(false)

        this.player.Native.Node.setProperty(visibleList, { visible: true })
        this.visibleList = visibleList

        if (res.perspective) {
          perspective = JSON.parse(res.perspective)
          this.player.Native.Camera.moveTo(perspective.eye, perspective.target, perspective.up, 1)
          this.currentNodeInfo.perspective = perspective
        }
        await this.createDyn()
      }
      this.loading = false
    },
    // 设置不展示面板
    async setDisabledPanel(showAll, codeList) {
      const openEvent = new CustomEvent('setDisabledPanel', {
        detail: {
          codeList: codeList || [],
          showAll,
        },
      })
      window.dispatchEvent(openEvent)
    },
    async setRootModelShow(show) {
      const root = await this.player.Native.Node.getRoot()
      await this.player.Native.Node.setProperty(root, { visible: show })
      // await this.player.Native.GisPlatform.setVisible(show)
    },
    // 返回初始视角
    async backInitPositon() {
      if (this.customProps.sceneOptions.cameraParams) {
        const { eye, target, up } = this.customProps.sceneOptions.cameraParams
        await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
        return
      }
      const rootNode = await this.player.Native.Node.getRoot()
      await this.player.Native.Camera.moveToNode(rootNode, 2)
    },
    async getAnimationList() {
      const [err, res] = await tagAnimationApi.getTagAnimationsByVirtualTagId({
        virtualTagId: this.currentNodeInfo.id,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        const animationList = []
        const codes = []
        res.forEach((item) => {
          item.config = JSON.parse(item.config)
          item.tagCode = item.threeDimensionalObjectCode
          if (item.status) {
            animationList.push(item)
            if (item.modelType === 'rotate') {
              codes.push(item.config.dynForm.clickTagCode)
            } else if (item.modelType === 'pipeFlow') {
              codes.push(item.tagCode)
            }
          }
        })
        this.animationList = animationList
        const res2 = await this.player.Native.Node.findNode(0, { codes })
        animationList.forEach((item) => {
          if (item.modelType === 'rotate' || item.modelType === 'pipeFlow') {
            const info = res2?.codes[item.tagCode] || res2?.codes[item.config.dynForm?.clickTagCode]
            item.node = info.node
            if (!item.node) {
              console.warn('未知code :>> ', item.node)
            }
          }
        })
      }
    },
    // 新建动效
    async createDyn() {
      await this.animationList.forEach(async (item) => {
        const dynForm = item.config.dynForm // 动效具体配置信息
        if (['fire', 'gas'].includes(item.modelType)) {
          const { particleObject } = await loadParticle({}, dynForm)
          this.dynInfo.particleNodes.push(particleObject)
        } else if (item.modelType === 'pipeFlow') {
          const UVA = new UVAnimation(this.player)
          await UVA.init(item.node, {}, dynForm.nodes)
          this.dynInfo.pipeDatas.push(UVA)
        } else {
          const baseData = {
            playerMode: dynForm.rotateType === 'sustainRotate' ? 1 : 0,
            rotateSpeed: dynForm.defalutRspeed,
            axis: dynForm.rotateAxis,
          }
          const { mixer, clip, action } = await loadRotationAction(item.node, item.node, baseData)
          this.player.Native.AnimationAction.play(action)
          this.dynInfo.rotDatas.push({ node: item.node, mixer, clip, action })
        }
      })
    },
    // 动效销毁
    async destroyDyn() {
      await this.destoryParticle()
      const mixer1 = await player.Native.AnimationMixer.getMixer('rotate')
      const mixer2 = await player.Native.AnimationMixer.getMixer('pipe')
      await this.player.Native.AnimationClip.clearClip(mixer1)
      await this.player.Native.AnimationClip.clearClip(mixer2)
      await this.destoryPipe()
      await this.destoryRotate()
    },

    // 销毁粒子动效
    async destoryParticle() {
      await this.player.Native.ParticleEffekseer.destroy([...this.dynInfo.particleNodes])
      this.dynInfo.particleNodes.length = 0
    },

    // 销毁管道流动动效
    async destoryPipe() {
      if (!this.dynInfo.pipeDatas.length) return
      this.dynInfo.pipeDatas.forEach((item) => {
        item.restore()
      })
      this.dynInfo.pipeDatas[0].clear()
      this.dynInfo.pipeDatas.length = 0
    },
    // 销毁旋转动效
    async destoryRotate() {
      const nodes = []
      this.dynInfo.rotDatas.forEach((item) => {
        nodes.push(item.node)
      })
      this.dynInfo.rotDatas.length = 0
      if (!nodes.length) return
      await this.player.Native.Node.setProperty(nodes, { localRot: [1, 0, 0, 0] })
    },
  },
  created() {
    this.modelSourceId = this.sourceId
    this.setCheckDisable(true)
    this.getTreeData()
  },
  async beforeDestroy() {
    await this.setRootModelShow(true)
    await this.backInitPositon()
    await this.destroyDyn()
    this.sendInfoToRightDialog('close')
    this.setCheckDisable(false)
    this.setDisabledPanel(true)
  },
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.tree-box {
  padding: 10px;
  margin-bottom: 10px;
  // height: calc(100% - 148px);
  height: calc(100% - 94px);
  border: 1px solid #45f2eb33;
}

::v-deep.three-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
</style>
